export default __webpack_public_path__ + "static/media/MD Arshad Khan.8a3dca86.pdf";